var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.place !== null)?_c('strong',{class:[_vm.place.balance < 0 ? 'pl-1 text-danger' : 'pl-1 text-success']},[_vm._v("₡ "+_vm._s(_vm.formatPrice(_vm.place.balance)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }